import { render, staticRenderFns } from "./Assistant.vue?vue&type=template&id=2fd83cc6&"
import script from "./Assistant.vue?vue&type=script&lang=js&"
export * from "./Assistant.vue?vue&type=script&lang=js&"
import style0 from "./Assistant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports